import { render } from "./Duo.vue?vue&type=template&id=d86c5c12&scoped=true"
import script from "./Duo.vue?vue&type=script&lang=js"
export * from "./Duo.vue?vue&type=script&lang=js"

import "./Duo.vue?vue&type=style&index=0&id=d86c5c12&lang=scss&scoped=true"

import exportComponent from "/Users/Sacha/Projects/muziekdichtbij/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d86c5c12"]])

export default __exports__